import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/exam-management/online`;

export const onlineExamManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create/:courseId`,
  edit: `${baseRoute}/edit/:courseId/:onlineExamId`,
  view: `${baseRoute}/view/:courseId`,
} as const;

export type IOnlineExamManagementRouteParams = IExtractRouteParamMap<
  typeof onlineExamManagementRoutesObj
>;

export const onlineExamManagementPath = createPaths<
  typeof onlineExamManagementRoutesObj,
  IOnlineExamManagementRouteParams
>(onlineExamManagementRoutesObj);
